import { render, staticRenderFns } from "./StoreReportList.vue?vue&type=template&id=14affb20&scoped=true"
import script from "./StoreReportList.vue?vue&type=script&lang=js"
export * from "./StoreReportList.vue?vue&type=script&lang=js"
import style0 from "./StoreReportList.vue?vue&type=style&index=0&id=14affb20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14affb20",
  null
  
)

export default component.exports